import { tv } from "../../variants/tv.js";
const sizeVariants = {
    20: {
        root: [
            'h-5 w-9 rounded-[calc(0.25rem*9)]',
            'after:-left-1 after:-top-3 after:w-11 after:h-11 hover:drop-shadow-md'
        ],
        tapSpaceSlot: '-left-1 -top-3 w-12 h-11',
        slider: 'inset-[2px] h-4 w-4 data-checked:translate-x-4'
    },
    24: {
        root: [
            'h-6 w-11 rounded-[calc(0.25rem*11)]',
            'after:-left-1 after:-top-3 after:w-13 after:h-12'
        ],
        tapSpaceSlot: '-left-1 -top-3 w-13 h-12',
        slider: 'inset-[2px] h-5 w-5 data-checked:translate-x-5'
    },
    32: {
        root: 'h-8 w-14 rounded-[calc(0.25rem*14)] ',
        slider: 'inset-1 h-6 w-6 data-checked:translate-x-6'
    }
};
const toggleSizes = Object.keys(sizeVariants);
const toggleEmphasisVariants = {
    regular: {
        root: `
      bg-primary-5
      hover:bg-primary-6
      focus-visible:outline-primary-8
      data-checked:bg-primary-8
      hover:data-checked:bg-primary-9
      data-disabled:bg-primary-2
      hover:data-disabled:bg-primary-2
    `,
        slider: `    
      bg-primary-1
      data-disabled:bg-primary-6
    `
    },
    medium: {
        root: `    
      bg-primary-5
      hover:bg-primary-6
      focus-visible:outline-primary-8
      data-checked:bg-primary-8
      hover:data-checked:bg-primary-9
      data-disabled:bg-primary-1/60
      hover:data-disabled:bg-primary-1/60
    `,
        slider: `     
      bg-primary-1
      data-disabled:bg-primary-6
    `
    },
    bold: {
        root: `    
      bg-primary-1/40      
      hover:bg-primary-1/40
      focus-visible:outline-primary-1
      data-checked:bg-primary-8
      hover:data-checked:bg-primary-9
      data-disabled:bg-primary-1/20
      hover:data-disabled:bg-primary-1/20      
    `,
        slider: `     
      bg-primary-1
      data-disabled:bg-primary-1/40
   `
    }
};
const toggleEmphases = Object.keys(toggleEmphasisVariants);
const toggleVariants = tv({
    slots: {
        root: 'data-checked:duration-extra-short data-checked:ease-out data-unchecked:duration-snap data-unchecked:ease-in data-disabled:cursor-not-allowed group relative flex cursor-pointer transition focus-visible:outline-2 focus-visible:outline-offset-2',
        tapSpaceSlot: 'absolute bg-transparent opacity-0',
        slider: 'data-disabled:shadow-none data-checked:transition absolute flex items-center justify-center rounded-full shadow-sm transition duration-300 group-hover:shadow-lg'
    },
    variants: {
        size: sizeVariants,
        emphasis: toggleEmphasisVariants
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular',
        size: '24'
    }
});
export { toggleEmphases, toggleEmphasisVariants, toggleSizes, toggleVariants };
